/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var spine_options_pb = require('../../../spine/options_pb.js');
var google_protobuf_any_pb = require('google-protobuf/google/protobuf/any_pb.js');
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.exportSymbol('proto.spine.server.delivery.ConsumerId', null, global);
goog.exportSymbol('proto.spine.server.delivery.ShardIndex', null, global);
goog.exportSymbol('proto.spine.server.delivery.ShardedMessage', null, global);
goog.exportSymbol('proto.spine.server.delivery.ShardedMessageId', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.server.delivery.ConsumerId = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.spine.server.delivery.ConsumerId, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.server.delivery.ConsumerId.displayName = 'proto.spine.server.delivery.ConsumerId';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.server.delivery.ConsumerId.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.server.delivery.ConsumerId.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.server.delivery.ConsumerId} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.server.delivery.ConsumerId.toObject = function(includeInstance, msg) {
  var f, obj = {
    consumerIdentity: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.server.delivery.ConsumerId}
 */
proto.spine.server.delivery.ConsumerId.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.server.delivery.ConsumerId;
  return proto.spine.server.delivery.ConsumerId.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.server.delivery.ConsumerId} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.server.delivery.ConsumerId}
 */
proto.spine.server.delivery.ConsumerId.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setConsumerIdentity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.server.delivery.ConsumerId.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.server.delivery.ConsumerId.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.server.delivery.ConsumerId} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.server.delivery.ConsumerId.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConsumerIdentity();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string consumer_identity = 1;
 * @return {string}
 */
proto.spine.server.delivery.ConsumerId.prototype.getConsumerIdentity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.spine.server.delivery.ConsumerId.prototype.setConsumerIdentity = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.server.delivery.ShardedMessageId = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.spine.server.delivery.ShardedMessageId, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.server.delivery.ShardedMessageId.displayName = 'proto.spine.server.delivery.ShardedMessageId';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.server.delivery.ShardedMessageId.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.server.delivery.ShardedMessageId.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.server.delivery.ShardedMessageId} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.server.delivery.ShardedMessageId.toObject = function(includeInstance, msg) {
  var f, obj = {
    value: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.server.delivery.ShardedMessageId}
 */
proto.spine.server.delivery.ShardedMessageId.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.server.delivery.ShardedMessageId;
  return proto.spine.server.delivery.ShardedMessageId.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.server.delivery.ShardedMessageId} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.server.delivery.ShardedMessageId}
 */
proto.spine.server.delivery.ShardedMessageId.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.server.delivery.ShardedMessageId.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.server.delivery.ShardedMessageId.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.server.delivery.ShardedMessageId} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.server.delivery.ShardedMessageId.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string value = 1;
 * @return {string}
 */
proto.spine.server.delivery.ShardedMessageId.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/** @param {string} value */
proto.spine.server.delivery.ShardedMessageId.prototype.setValue = function(value) {
  jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.server.delivery.ShardedMessage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.spine.server.delivery.ShardedMessage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.server.delivery.ShardedMessage.displayName = 'proto.spine.server.delivery.ShardedMessage';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.server.delivery.ShardedMessage.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.server.delivery.ShardedMessage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.server.delivery.ShardedMessage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.server.delivery.ShardedMessage.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: (f = msg.getId()) && proto.spine.server.delivery.ShardedMessageId.toObject(includeInstance, f),
    targetId: (f = msg.getTargetId()) && google_protobuf_any_pb.Any.toObject(includeInstance, f),
    originalMessage: (f = msg.getOriginalMessage()) && google_protobuf_any_pb.Any.toObject(includeInstance, f),
    whenSharded: (f = msg.getWhenSharded()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.server.delivery.ShardedMessage}
 */
proto.spine.server.delivery.ShardedMessage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.server.delivery.ShardedMessage;
  return proto.spine.server.delivery.ShardedMessage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.server.delivery.ShardedMessage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.server.delivery.ShardedMessage}
 */
proto.spine.server.delivery.ShardedMessage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.spine.server.delivery.ShardedMessageId;
      reader.readMessage(value,proto.spine.server.delivery.ShardedMessageId.deserializeBinaryFromReader);
      msg.setId(value);
      break;
    case 2:
      var value = new google_protobuf_any_pb.Any;
      reader.readMessage(value,google_protobuf_any_pb.Any.deserializeBinaryFromReader);
      msg.setTargetId(value);
      break;
    case 3:
      var value = new google_protobuf_any_pb.Any;
      reader.readMessage(value,google_protobuf_any_pb.Any.deserializeBinaryFromReader);
      msg.setOriginalMessage(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setWhenSharded(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.server.delivery.ShardedMessage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.server.delivery.ShardedMessage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.server.delivery.ShardedMessage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.server.delivery.ShardedMessage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.spine.server.delivery.ShardedMessageId.serializeBinaryToWriter
    );
  }
  f = message.getTargetId();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_any_pb.Any.serializeBinaryToWriter
    );
  }
  f = message.getOriginalMessage();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_any_pb.Any.serializeBinaryToWriter
    );
  }
  f = message.getWhenSharded();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional ShardedMessageId id = 1;
 * @return {?proto.spine.server.delivery.ShardedMessageId}
 */
proto.spine.server.delivery.ShardedMessage.prototype.getId = function() {
  return /** @type{?proto.spine.server.delivery.ShardedMessageId} */ (
    jspb.Message.getWrapperField(this, proto.spine.server.delivery.ShardedMessageId, 1));
};


/** @param {?proto.spine.server.delivery.ShardedMessageId|undefined} value */
proto.spine.server.delivery.ShardedMessage.prototype.setId = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.spine.server.delivery.ShardedMessage.prototype.clearId = function() {
  this.setId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.server.delivery.ShardedMessage.prototype.hasId = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Any target_id = 2;
 * @return {?proto.google.protobuf.Any}
 */
proto.spine.server.delivery.ShardedMessage.prototype.getTargetId = function() {
  return /** @type{?proto.google.protobuf.Any} */ (
    jspb.Message.getWrapperField(this, google_protobuf_any_pb.Any, 2));
};


/** @param {?proto.google.protobuf.Any|undefined} value */
proto.spine.server.delivery.ShardedMessage.prototype.setTargetId = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.spine.server.delivery.ShardedMessage.prototype.clearTargetId = function() {
  this.setTargetId(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.server.delivery.ShardedMessage.prototype.hasTargetId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Any original_message = 3;
 * @return {?proto.google.protobuf.Any}
 */
proto.spine.server.delivery.ShardedMessage.prototype.getOriginalMessage = function() {
  return /** @type{?proto.google.protobuf.Any} */ (
    jspb.Message.getWrapperField(this, google_protobuf_any_pb.Any, 3));
};


/** @param {?proto.google.protobuf.Any|undefined} value */
proto.spine.server.delivery.ShardedMessage.prototype.setOriginalMessage = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


proto.spine.server.delivery.ShardedMessage.prototype.clearOriginalMessage = function() {
  this.setOriginalMessage(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.server.delivery.ShardedMessage.prototype.hasOriginalMessage = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Timestamp when_sharded = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.spine.server.delivery.ShardedMessage.prototype.getWhenSharded = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/** @param {?proto.google.protobuf.Timestamp|undefined} value */
proto.spine.server.delivery.ShardedMessage.prototype.setWhenSharded = function(value) {
  jspb.Message.setWrapperField(this, 4, value);
};


proto.spine.server.delivery.ShardedMessage.prototype.clearWhenSharded = function() {
  this.setWhenSharded(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.server.delivery.ShardedMessage.prototype.hasWhenSharded = function() {
  return jspb.Message.getField(this, 4) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.server.delivery.ShardIndex = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.spine.server.delivery.ShardIndex, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.server.delivery.ShardIndex.displayName = 'proto.spine.server.delivery.ShardIndex';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.server.delivery.ShardIndex.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.server.delivery.ShardIndex.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.server.delivery.ShardIndex} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.server.delivery.ShardIndex.toObject = function(includeInstance, msg) {
  var f, obj = {
    index: jspb.Message.getFieldWithDefault(msg, 1, 0),
    ofTotal: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.server.delivery.ShardIndex}
 */
proto.spine.server.delivery.ShardIndex.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.server.delivery.ShardIndex;
  return proto.spine.server.delivery.ShardIndex.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.server.delivery.ShardIndex} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.server.delivery.ShardIndex}
 */
proto.spine.server.delivery.ShardIndex.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setIndex(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOfTotal(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.server.delivery.ShardIndex.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.server.delivery.ShardIndex.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.server.delivery.ShardIndex} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.server.delivery.ShardIndex.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIndex();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getOfTotal();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
};


/**
 * optional int32 index = 1;
 * @return {number}
 */
proto.spine.server.delivery.ShardIndex.prototype.getIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/** @param {number} value */
proto.spine.server.delivery.ShardIndex.prototype.setIndex = function(value) {
  jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 of_total = 2;
 * @return {number}
 */
proto.spine.server.delivery.ShardIndex.prototype.getOfTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/** @param {number} value */
proto.spine.server.delivery.ShardIndex.prototype.setOfTotal = function(value) {
  jspb.Message.setProto3IntField(this, 2, value);
};


goog.object.extend(exports, proto.spine.server.delivery);

// The code for parsing the Protobuf messages of this file from the JSON data.

let known_type_parsers = require('../../../known_type_parsers.js');

proto.spine.server.delivery.ConsumerId.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.server.delivery.ConsumerId.fromObject(jsObject);
};

proto.spine.server.delivery.ConsumerId.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.server.delivery.ConsumerId();
  
  if (obj.consumerIdentity !== undefined) {
    if (obj.consumerIdentity !== null) {
      let value = obj.consumerIdentity;
      msg.setConsumerIdentity(value);
    }
  }
  return msg;
};

proto.spine.server.delivery.ShardedMessageId.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.server.delivery.ShardedMessageId.fromObject(jsObject);
};

proto.spine.server.delivery.ShardedMessageId.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.server.delivery.ShardedMessageId();
  
  if (obj.value !== undefined) {
    if (obj.value !== null) {
      let value = obj.value;
      msg.setValue(value);
    }
  }
  return msg;
};

proto.spine.server.delivery.ShardedMessage.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.server.delivery.ShardedMessage.fromObject(jsObject);
};

proto.spine.server.delivery.ShardedMessage.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.server.delivery.ShardedMessage();
  
  if (obj.id !== undefined) {
    if (obj.id === null) {
      msg.setId(null);
    } else {
      let value = proto.spine.server.delivery.ShardedMessageId.fromObject(obj.id);
      msg.setId(value);
    }
  }
  
  if (obj.targetId !== undefined) {
    if (obj.targetId === null) {
      msg.setTargetId(null);
    } else {
      let parser = known_type_parsers.parsers.get('type.googleapis.com/google.protobuf.Any');
      let value = parser.parse(obj.targetId);
      msg.setTargetId(value);
    }
  }
  
  if (obj.originalMessage !== undefined) {
    if (obj.originalMessage === null) {
      msg.setOriginalMessage(null);
    } else {
      let parser = known_type_parsers.parsers.get('type.googleapis.com/google.protobuf.Any');
      let value = parser.parse(obj.originalMessage);
      msg.setOriginalMessage(value);
    }
  }
  
  if (obj.whenSharded !== undefined) {
    if (obj.whenSharded === null) {
      msg.setWhenSharded(null);
    } else {
      let parser = known_type_parsers.parsers.get('type.googleapis.com/google.protobuf.Timestamp');
      let value = parser.parse(obj.whenSharded);
      msg.setWhenSharded(value);
    }
  }
  return msg;
};

proto.spine.server.delivery.ShardIndex.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.server.delivery.ShardIndex.fromObject(jsObject);
};

proto.spine.server.delivery.ShardIndex.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.server.delivery.ShardIndex();
  
  if (obj.index !== undefined) {
    if (obj.index !== null) {
      let value = obj.index;
      msg.setIndex(value);
    }
  }
  
  if (obj.ofTotal !== undefined) {
    if (obj.ofTotal !== null) {
      let value = obj.ofTotal;
      msg.setOfTotal(value);
    }
  }
  return msg;
};
